import Phone from "@homeinstead/icons/Phone";
import { cva } from "class-variance-authority";

export const ICONS = {
  phone: Phone,
};

export const richTextVariants = cva("rich-text", {
  variants: {
    textColor: {
      "new-beginnings": "text-new-beginnings-base",
      support: "text-support-base",
      white: "text-white",
    },
  },
});

type SpacingValue = "0" | "2" | "4" | "6" | "8";

const LINK_SPACING_SCALE: Record<string, SpacingValue> = {
  "2": "2",
  "4": "4",
  "6": "6",
  "8": "8",
  none: "0",
};

const LEGACY_LINK_SPACING_SCALE: Record<string, SpacingValue> = {
  default: "4",
  slim: "2",
};

const MY_CLASSES: Record<SpacingValue, string> = {
  "0": "my-0",
  "2": "my-2",
  "4": "my-4",
  "6": "my-6",
  "8": "my-8",
};

const MT_CLASSES: Record<SpacingValue, string> = {
  "0": "mt-0",
  "2": "mt-2",
  "4": "mt-4",
  "6": "mt-6",
  "8": "mt-8",
};

// These variants are used on hi-care and some other places so to not break something there it is here
export const linkVariants = cva("", {
  variants: {
    variant: {
      holiday: "inline text-wrap p-0",
      plain: "inline text-wrap p-0",
    },
    withIcon: {
      true: "inline-flex items-center gap-2",
    },
  },
});

export function resolveLinkSpacingClasses(
  verticalSpacing?: string,
  topSpacing?: string,
) {
  if (!verticalSpacing && !topSpacing) {
    return "";
  }

  const verticalValue = verticalSpacing
    ? (LINK_SPACING_SCALE[verticalSpacing] ??
      LEGACY_LINK_SPACING_SCALE[verticalSpacing])
    : undefined;
  const topValue = topSpacing
    ? (LINK_SPACING_SCALE[topSpacing] ?? LEGACY_LINK_SPACING_SCALE[topSpacing])
    : undefined;

  if (verticalValue && topValue) {
    return `${MY_CLASSES[verticalValue]} ${MT_CLASSES[topValue]}`;
  }

  if (verticalValue) {
    return MY_CLASSES[verticalValue];
  }

  return topValue ? MT_CLASSES[topValue] : "";
}

export const linkIconVariants = cva("", {
  variants: {
    linkVariant: {
      friendly: "fill-new-beginnings-base",
      holiday: "fill-holiday",
      "outline-dark": "fill-white",
      primary: "fill-support-base",
      secondary: "fill-new-beginnings-base",
    },
  },
});
